import { render, staticRenderFns } from "./HelpText.vue?vue&type=template&id=a1476532&"
import script from "./HelpText.vue?vue&type=script&lang=js&"
export * from "./HelpText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports